// Detect YouTube / Facebook video & live links in post text → embeddable player src.

const YT_PATTERNS = [
  /(?:https?:\/\/)?(?:www\.|m\.)?youtube\.com\/watch\?[^\s]*v=([\w-]{6,20})/i,
  /(?:https?:\/\/)?youtu\.be\/([\w-]{6,20})/i,
  /(?:https?:\/\/)?(?:www\.|m\.)?youtube\.com\/shorts\/([\w-]{6,20})/i,
  /(?:https?:\/\/)?(?:www\.|m\.)?youtube\.com\/live\/([\w-]{6,20})/i,
  /(?:https?:\/\/)?(?:www\.|m\.)?youtube\.com\/embed\/([\w-]{6,20})/i,
];

const FB_PATTERNS = [
  /(?:https?:\/\/)?(?:www\.|m\.|web\.)?facebook\.com\/[^\s]+\/videos\/[^\s]+/i,
  /(?:https?:\/\/)?(?:www\.|m\.)?facebook\.com\/watch\/?\?[^\s]*v=\d+/i,
  /(?:https?:\/\/)?(?:www\.|m\.)?facebook\.com\/reel\/\d+[^\s]*/i,
  /(?:https?:\/\/)?fb\.watch\/[\w-]+\/?/i,
  /(?:https?:\/\/)?(?:www\.|m\.)?facebook\.com\/[^\s]+\/live\/?[^\s]*/i,
];

/** First http(s) URL found in text, or null. */
export const parseFirstUrl = (text) => {
  const m = /https?:\/\/[^\s]+/i.exec(text || "");
  return m ? m[0] : null;
};

/** Returns {provider: 'youtube'|'facebook', src, url} or null. */
export const parseVideoEmbed = (text) => {
  if (!text) return null;
  for (const re of YT_PATTERNS) {
    const m = text.match(re);
    if (m) {
      return {
        provider: "youtube",
        url: m[0],
        videoId: m[1],
        src: `https://www.youtube.com/embed/${m[1]}?autoplay=1&mute=1&playsinline=1&rel=0`,
      };
    }
  }
  for (const re of FB_PATTERNS) {
    const m = text.match(re);
    if (m) {
      let full = m[0];
      if (!/^https?:\/\//i.test(full)) full = `https://${full}`;
      return {
        provider: "facebook",
        url: full,
        src: `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(full)}&autoplay=true&mute=true&show_text=false`,
      };
    }
  }
  return null;
};
